module.exports = __webpack_public_path__ + "img/NotificationsIcon.19cc9df3.png";